import React from 'react';

const CustomChip = ({ icon, label, onClick, style }) => {
  return (
    <div 
      onClick={onClick} 
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '30px',
        borderRadius: '20px',
        backgroundColor: '#e0e0e0',
        cursor: 'pointer',
        userSelect: 'none',
        overflow: 'hidden',
        ...style
      }}
    >
      {icon && (
        <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          {icon}
        </span>
      )}
      {label && <span style={{ marginLeft: icon ? 8 : 0 }}>{label}</span>}
    </div>
  );
};

export default CustomChip;
